// @flow

import { type Receipt } from '../types';
import { type Amount } from '@tectonics/prs/money';

export function getAmountExt(receipt: Receipt): Amount {
  return receipt['amount_ext'];
}
